// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import "../styles/RdDdReport.css";

// const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
// const rowsPerPage = 10;

// const RdDdReport = () => {
//   const [activeMainTab, setActiveMainTab] = useState("RD");
//   const [activeSecondary, setActiveSecondary] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // ✅ Fetch API Data
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       const superAdminId = localStorage.getItem("superAdminId") || 14;

//       const res = await axios.get("https://payyug.in/api/deposit/list", {
//         params: {
//           superAdminId,
//           page: currentPage,
//           limit: rowsPerPage,
//           accountType: activeMainTab,
//           status: activeSecondary !== "All" ? activeSecondary : undefined,
//           search: searchQuery || undefined,
//         },
//       });

//       if (res.data.success) {
//         setAccounts(res.data.data || []);
//         setTotalPages(res.data.totalPages || 1);
//       } else {
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching deposit accounts:", err);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch whenever filters or page changes
//   useEffect(() => {
//     fetchAccounts();
//   }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

//   // Reset page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [activeMainTab, activeSecondary]);

//   // Render Table
//   const renderTable = useMemo(() => {
//     if (loading) {
//       return (
//         <tr>
//           <td colSpan="10" style={{ textAlign: "center" }}>
//             Loading...
//           </td>
//         </tr>
//       );
//     }

//     if (!accounts.length) {
//       return (
//         <tr>
//           <td colSpan="10" style={{ textAlign: "center" }}>
//             No Data Found
//           </td>
//         </tr>
//       );
//     }

//     return accounts.map((acc, index) => (
//       <tr key={acc.id}>
//         <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//         <td>{acc.accountNo}</td>
//         <td>{acc.customerName || "--"}</td>
//         <td>{acc.accountType || "--"}</td>
//         <td>{acc.roi || "--"}%</td>
//         <td>₹{acc.minDeposit || 0}</td>
//         <td>₹{acc.loanAmount || 0}</td>
//         <td>{acc.lockinPeriod || 0}</td>
//         <td>{acc.referId || "--"}</td>
//         <td>{acc.nomineeId || "--"}</td>
//         <td>
//           <button
//             className="DDFDReportview-btn"
//             onClick={() => alert(`Viewing ${acc.accountNo}`)}
//           >
//             View
//           </button>
//         </td>
//       </tr>
//     ));
//   }, [accounts, loading, currentPage]);

//   return (
//     <div className="DDFDReport-container">
//       <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//         {activeMainTab} Account Report
//       </h2>

//       {/* Tabs */}
//       <div className="DDFDReport-main-tabs">
//         {["RD", "DD"].map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-main-btn ${
//               activeMainTab === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveMainTab(tab)}
//           >
//             {tab} Report
//           </button>
//         ))}
//       </div>

//       {/* Secondary Tabs */}
//       <div className="DDFDReport-secondary-tabs">
//         {secondaryTabs.map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-secondary-btn ${
//               activeSecondary === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveSecondary(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Search */}
//       <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by Account No / Customer..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>
// {/* Table */}
// <div className="DDFDReporttable-container">
//   <table className="DDFDReport-table">
//     <thead>
//       <tr>
//         <th>SN</th>
//         <th>Account No</th>
//         <th>Customer Name</th>
//         <th>Account Type</th>
//         <th>Status</th>               {/* NEW */}
//         <th>Roi</th>
//         <th>Deposit Amount</th>       {/* NEW */}
//         <th>Tenure</th>               {/* NEW */}

//         {/* <th>Nominee ID</th> */}
//         <th>Action</th>
//       </tr>
//     </thead>

//     <tbody>
//       {loading ? (
//         <tr>
//           <td colSpan="14" style={{ textAlign: "center" }}>Loading...</td>
//         </tr>
//       ) : accounts.length === 0 ? (
//         <tr>
//           <td colSpan="14" style={{ textAlign: "center" }}>No Data Found</td>
//         </tr>
//       ) : (
//         accounts.map((acc, index) => (
//           <tr key={acc.id}>
//             <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//             <td>{acc.accountNo}</td>
//             <td>{acc.customerName || "--"}</td>
//             <td>{acc.accountType || "--"}</td>

//             {/* NEW STATUS FIELD */}
//             <td>{acc.status || "--"}</td>

//             <td>{acc.roi || "--"}%</td>

//             {/* NEW DEPOSIT AMOUNT */}
//             <td>₹{acc.amount || acc.minDeposit || 0}</td>

//             {/* NEW TENURE */}
//             <td>{acc.tenure || "--"}</td>

//             {/* <td>{acc.nomineeName || "--"}</td> */}

//             <td>
//               <button
//                 className="DDFDReportview-btn"
//                 onClick={() => alert(`Viewing ${acc.accountNo}`)}
//               >
//                 View
//               </button>
//             </td>
//           </tr>
//         ))
//       )}
//     </tbody>
//   </table>
// </div>

//       {/* Pagination */}
//       <div className="DDFDReportpagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           Previous
//         </button>
//         <span>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default RdDdReport;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../styles/RdDdReport.css";
// import { useRef } from "react";
// import { useReactToPrint } from "react-to-print";
// const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
// const rowsPerPage = 10;

// const RdDdReport = () => {
//   const [activeMainTab, setActiveMainTab] = useState("RD");
//   const [activeSecondary, setActiveSecondary] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [openViewModal,setOpenViewModal]=useState(false)
//   const [selectedRow,setSelectedRow]=useState(null)

//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(false);
// //   const slipRef = useRef(null);
// //   const [selectedAcc, setSelectedAcc] = useState(null);

// //   useEffect(() => {
// //   if (selectedAcc) {
// //     setTimeout(() => {
// //       handlePrint();
// //     }, 50);
// //   }
// // }, [selectedAcc]);

//   // const handlePrint = useReactToPrint({
//   //   contentRef: slipRef,
//   //   documentTitle: "Slip",
//   //   pageStyle: `
//   //     @page { size: 58mm auto; margin: 0; }
//   //     body { -webkit-print-color-adjust: exact; }
//   //   `,
//   // });

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // Dialog States
//   const [showDialog, setShowDialog] = useState(false);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [approveLoading, setApproveLoading] = useState(false);

//   // ============================
//   // ✅ Fetch Deposit Accounts
//   // ============================
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);

//   const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

//       const res = await axios.get("https://payyug.in/api/deposit/list", {
//         params: {
//           superAdminId,
//           page: currentPage,
//           limit: rowsPerPage,
//           accountType: activeMainTab,
//           status: activeSecondary !== "All" ? activeSecondary : undefined,
//           search: searchQuery || undefined,
//         },
//       });

//       const accounts = Array.isArray(res?.data?.data)
//       ? res.data.data
//       : [];

//     // Remove pending accounts safely
//     const filteredAccounts = accounts.filter(
//       (acc) =>
//         acc?.status &&
//         acc.status.trim().toLowerCase() !== "pending"
//     );

//       if (res.data.success) {
//         setAccounts(filteredAccounts);
//         setTotalPages(res.data.totalPages || 1);
//       }
//     } catch (err) {
//       console.error(err);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAccounts();
//   }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [activeMainTab, activeSecondary]);

//   // ============================
//   // 🟢 Open Approve Modal
//   // ============================
//   const openApproveDialog = (account) => {
//     setSelectedAccount(account);
//     setShowDialog(true);
//   };

//   // ============================
//   // 🟢 Approve API
//   // ============================
//   const approveAccount = async () => {
//     try {
//       setApproveLoading(true);

//       const employee = localStorage.getItem("adminuserId") || "Admin";

//       const res = await axios.post(
//         "https://payyug.in/api/deposit-account/approve",
//         {
//           accountId: selectedAccount.id,
//           approvedBy: employee,
//           remarks: "Approved from RD/DD report",
//         }
//       );

//       if (res.data.success) {
//         alert("Account Approved Successfully!");
//         setShowDialog(false);
//         fetchAccounts(); // Refresh list
//       } else {
//         alert(res.data.message);
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Approval failed.");
//     } finally {
//       setApproveLoading(false);
//     }
//   };

//   return (
//     <div className="DDFDReport-container">
//         <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//           {activeMainTab} Account Report
//         </h2>

//         {/* Tabs */}
//         <div className="DDFDReport-main-tabs">
//           {["RD", "DD"].map((tab) => (
//             <button
//               key={tab}
//               className={`DDFDReport-main-btn ${
//                 activeMainTab === tab ? "active" : ""
//               }`}
//               onClick={() => setActiveMainTab(tab)}
//             >
//               {tab} Report
//             </button>
//           ))}
//         </div>

//         {/* Secondary Tabs */}
//         <div className="DDFDReport-secondary-tabs">
//           {secondaryTabs.map((tab) => (
//             <button
//               key={tab}
//               className={`DDFDReport-secondary-btn ${
//                 activeSecondary === tab ? "active" : ""
//               }`}
//               onClick={() => setActiveSecondary(tab)}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>

//       {/* SEARCH */}
//       <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by Account No / Customer..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {/* TABLE */}
//       <div className="DDFDReporttable-container">
//         <table className="DDFDReport-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer</th>
//               <th>Type</th>
//               <th>ROI</th>
//               <th>Amount</th>
//               <th>Tenure</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="10" style={{ textAlign: "center" }}>
//                   Loading...
//                 </td>
//               </tr>
//             ) : accounts.length === 0 ? (
//               <tr>
//                 <td colSpan="10" style={{ textAlign: "center" }}>
//                   No Data Found
//                 </td>
//               </tr>
//             ) : (
//               accounts.map((acc, index) => (
//                 <tr key={acc.id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{acc.accountNo}</td>
//                   <td>{acc.customerName || "--"}</td>
//                   <td>{acc.accountType}</td>
//                   <td>{acc.roi}%</td>
//                   <td>₹{acc.amount}</td>
//                   <td>{acc.tenure}</td>
//                   <td>{acc.status}</td>

//                   <td>
//                     <button
//                       className="DDFDReportview-btn"
//                       onClick={() => {
//                         setOpenViewModal(true)
//                         setSelectedRow(acc)

//                       }}
//                       style={{marginRight:"7px"}}
//                     >
//                       View
//                     </button>

//                     {/* {acc.status === "Pending" && (
//                       <button
//                         className="approve-btn"
//                         onClick={() => openApproveDialog(acc)}
//                       >
//                         Approve
//                       </button>
//                     )} */}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* PAGINATION */}
//       <div className="DDFDReportpagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           Previous
//         </button>
//         <span>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next
//         </button>
//       </div>

//       {/* APPROVE MODAL */}
//       {showDialog && selectedAccount && (
//         <div className="dialog-overlay">
//           <div className="dialog-box">
//             <h3>Approve Deposit Account</h3>

//             <p><b>Account No:</b> {selectedAccount.accountNo}</p>
//             <p><b>Name:</b> {selectedAccount.customerName}</p>
//             <p><b>Amount:</b> ₹{selectedAccount.amount}</p>
//             <p><b>Tenure:</b> {selectedAccount.tenure} </p>
//             <p><b>Status:</b> {selectedAccount.status}</p>

//             <div className="dialog-actions">
//               <button onClick={() => setShowDialog(false)}>Close</button>

//               <button
//                 className="approve-btn"
//                 onClick={approveAccount}
//                 disabled={approveLoading}
//               >
//                 {approveLoading ? "Approving..." : "Approve"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {openViewModal && selectedRow && (
//         <div className="dialog-overlay">
//           <div className="dialog-box">
//             <h3>{`${selectedRow.accountType} Account Details`}</h3>
//             <p><b>Account No:</b> {selectedRow.accountNo||"N/A"}</p>
//             <p><b>Customer Name:</b> {selectedRow.customerName||"N/A"}</p>
//             <p><b>Account Type:</b> {selectedRow.accountType||"N/A"}</p>
//             <p><b>Amount:</b> {`₹${selectedRow.amount}`||"N/A"}</p>
//             <p><b>Roi:</b> {`${selectedRow.roi}%`||"N/A"}</p>
//             <p><b>Tenure:</b> {selectedRow.tenure||"N/A"} </p>
//             <p><b>Status:</b> {selectedRow.status||"N/A"}</p>

//             <div className="dialog-actions">
//               <button onClick={() => setOpenViewModal(false)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default RdDdReport;

import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "../styles/RdDdReport.css";
import { toast, ToastContainer } from "react-toastify";
import { Eye, Trash, X } from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
const secondaryTabs = [
  "All",
  "Pending",
  "Active",
  "Closed",
  "Matured",
  "Pre-Closed",
  "Reject",
];

const hostname = window.location.hostname.split(".")[0];
console.log("hostanem", hostname);

const RdDdReport = () => {
  const [activeMainTab, setActiveMainTab] = useState("RD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [frequency, setFrequency] = useState("All");
  const [adminRemark, setAdminRemark] = useState("");

  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [closeLoading, setCloseLoading] = useState(false);

  const fetchAccounts = async () => {
    try {
      setLoading(true);

      const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

      const res = await axios.get("https://payyug.in/api/deposit/list", {
        params: {
          superAdminId,
          accountType: activeMainTab,
        },
      });

      const accounts = Array.isArray(res?.data?.data) ? res.data.data : [];

      // Remove pending accounts safely
      // const filtered = accounts.filter(
      //   (acc) =>
      //     acc?.status &&
      //     acc.status.trim().toLowerCase() !== "pending"
      // );

      if (res.data.success) {
        setAccounts(accounts);
      }
    } catch (err) {
      console.error(err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, [activeMainTab]);

  const filteredAccounts = useMemo(() => {
    let data = [...accounts];

    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();

      data = data.filter(
        (acc) =>
          acc.accountNo?.toLowerCase().includes(query) ||
          acc.customerName?.toLowerCase().includes(query),
      );
    }

    // 🔹 STATUS FILTER
    if (activeSecondary !== "All") {
      data = data.filter(
        (acc) => acc.status?.toLowerCase() === activeSecondary.toLowerCase(),
      );
    }

    // 🔹 FREQUENCY FILTER
    if (frequency !== "All") {
      data = data.filter(
        (acc) =>
          acc.installmentFrequency?.toLowerCase() === frequency.toLowerCase(),
      );
    }

    return data;
  }, [accounts, activeSecondary, frequency, searchQuery]);

  // pagination(frontend)
  const totalPages = Math.max(
    1,
    Math.ceil(filteredAccounts.length / itemsPerPage),
  );

  const paginatedAccounts = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return filteredAccounts.slice(start, end);
  }, [filteredAccounts, currentPage, itemsPerPage]);

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeSecondary, searchQuery, frequency, itemsPerPage]);

  // delete account
  const handleDelete = async (accountId, accountNo) => {
    const confirm = window.confirm(
      `Are you sure to delete this Account= ${accountNo}`,
    );
    if (confirm) {
      const result = await axios.delete(
        `https://payyug.in/api/deposit/delete/${accountId}`,
      );
      toast.success(result.data.message || "Deleted Successfully");
    }
    fetchAccounts();
  };

  // ============================
  // 🟢 Open Approve Modal
  // ============================
  const openCloseDialog = (account) => {
    setSelectedAccount(account);
    setShowDialog(true);
  };

  // ============================
  // 🟢 Approve API
  // ============================
  const closeAccount = async () => {
    try {
      setCloseLoading(true);

      const superAdminId = localStorage.getItem("adminuserId") || "Admin";

      const res = await axios.post(
        "https://payyug.in/api/deposit/close-account",
        {
          accountId: selectedAccount.id,
          closedBy: superAdminId,
          remarks: adminRemark,
        },
      );

      if (res.data.success) {
        toast.success(
          res.data.message || `${selectedAccount.accountNo} account closed`,
        );
        setShowDialog(false);
        fetchAccounts(); // Refresh list
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data.message);
    } finally {
      setCloseLoading(false);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="rddd-account-report-container">
      {/* Filter Section */}
      <section className="rddd-report-filters-section">
        <h2 style={{ textAlign: "center", marginBottom: 10 }}>
          {activeMainTab} Account Report
        </h2>

        {/* Main Tabs */}
        <div className="rddd-report-filters-main-tabs">
          {["RD", "DD"].map((tab) => (
            <button
              key={tab}
              className={`rddd-report-filters-main-tab ${
                activeMainTab === tab ? "active" : ""
              }`}
              onClick={() => setActiveMainTab(tab)}
            >
              {tab} Report
            </button>
          ))}
        </div>

        {/* Secondary Tabs */}
        <div className="rddd-report-filters-secondary-tabs">
          {secondaryTabs.map((tab) => (
            <button
              key={tab}
              className={`rddd-report-filters-secondary-btn ${
                activeSecondary === tab ? "active" : ""
              }`}
              onClick={() => setActiveSecondary(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* <div className="dropdown-filter ">
           <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
          <option value="All">All</option>
          <option value="Daily">Daily</option>
          <option value="Weekly">Weekly</option>
          <option value="Monthly">Monthly</option>
        </select>
      </div> */}
      </section>

      <div className="rddd-report-search-section">
        <div>
          <label>Show </label>
          <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
            {ITEMS_PER_PAGE_OPTIONS.map((count) => (
              <option key={count} value={count}>
                {count}
              </option>
            ))}
          </select>
          <span> entries</span>
        </div>
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="rddd-report-table-wrapper">
        <table className="rddd-report-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer</th>
              <th>Type</th>
              <th>ROI</th>
              <th>Amount</th>
              <th>Tenure</th>
              <th>Opening Date</th>
              {hostname === "samvatsaranidhi" ? (
                <th>Total Deposited</th>
              ) : (
                <>
                  <th>Principal Amount</th>
                  <th>Total Interest</th>
                  {/* <th>Installment Amount</th> */}
                  <th>Maturity Amount</th>
                </>
              )}

              <th>Status</th>
              <th>Close</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="14" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : paginatedAccounts.length === 0 ? (
              <tr>
                <td colSpan="14" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            ) : (
              paginatedAccounts.map((acc, index) => (
                <tr key={acc.id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{acc.accountNo || "N/A"}</td>
                  <td>{acc.customerName || "N/A"}</td>
                  <td>{acc.accountType || "N/A"}</td>
                  <td>{`${acc.roi}%` || "N/A"}</td>
                  <td>{`₹${acc.amount}` || "N/A"}</td>
                  <td>{acc.tenure || "N/A"}</td>
                  <td>{acc.openingDate? new Date(acc.openingDate).toLocaleDateString("en-GB"):"N/A"}</td>
                  {hostname === "samvatsaranidhi" ? (
                    <td>{`₹${acc.totalDeposited}` || "N/A"}</td>
                  ) : (
                    <>
                      <td>{`₹${acc.principalAmount}` || "N/A"}</td>
                      <td>{`₹${acc.totalInterest}` || "N/A"}</td>
                      <td>{`₹${acc.maturityAmount}` || "N/A"}</td>
                    </>
                  )}
                  <td>{acc.status || "N/A"}</td>
                  <td>
                    {acc.status.toLowerCase() === "pending" ? (
                      "After Verify"
                    ) : (
                      <button
                        className="approve-btn"
                        onClick={() => openCloseDialog(acc)}
                        disabled={acc.status.toLowerCase() === "closed"}
                      >
                        {acc.status.toLowerCase() === "closed"
                          ? "Closed"
                          : "Close"}
                      </button>
                    )}
                  </td>

                  <td>
                    <button
                      className="rddd-report-table-action-view"
                      onClick={() => {
                        setOpenViewModal(true);
                        setSelectedRow(acc);
                      }}
                      style={{ marginRight: "7px" }}
                    >
                      <Eye />
                    </button>

                    <button
                      className="approve-btn"
                      onClick={() => handleDelete(acc.id, acc.accountNo)}
                    >
                      <Trash />
                    </button>

                    {/* {acc.status === "Pending" && (
                      <button
                        className="approve-btn"
                        onClick={() => openApproveDialog(acc)}
                      >
                        Approve
                      </button>
                    )} */}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="rddd-report-pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Close MODAL */}
      {showDialog && selectedAccount && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h3>Close {selectedAccount.accountType} Account</h3>

            <p>
              <b>Account No:</b> {selectedAccount.accountNo}
            </p>
            <div className="dialog-close-input">
              <label htmlFor="">Remark</label>
              <textarea
                placeholder="Enter admin remark"
                value={adminRemark}
                onChange={(e) => setAdminRemark(e.target.value)}
              ></textarea>
            </div>

            <div className="dialog-actions">
              <button
                className="approve-btn"
                onClick={closeAccount}
                disabled={closeLoading}
              >
                {closeLoading ? "Closing..." : "Close"}
              </button>
              <button onClick={() => setShowDialog(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {openViewModal && selectedRow && (
        <div className="rddd-dialog-overlay">
          <div className="rddd-dialog-box">
            <button
              className="rddd-dialog-close"
              onClick={() => setOpenViewModal(false)}
            >
              <X size={20} />
            </button>

            <div className="rddd-dialog-header">
              <h3>{selectedRow.accountType} Account Details</h3>
            </div>

            <div className="rddd-dialog-grid">
              <div className="rddd-dialog-item">
                <span>Account No</span>
                <strong>{selectedRow.accountNo || "N/A"}</strong>
              </div>

              <div className="rddd-dialog-item">
                <span>Customer Name</span>
                <strong>{selectedRow.customerName || "N/A"}</strong>
              </div>

              <div className="rddd-dialog-item">
                <span>Account Type</span>
                <strong>{selectedRow.accountType || "N/A"}</strong>
              </div>

              <div className="rddd-dialog-item highlight">
                <span>Amount</span>
                <strong>₹{selectedRow.amount || "0"}</strong>
              </div>

              <div className="rddd-dialog-item">
                <span>ROI</span>
                <strong>{selectedRow.roi || "0"}%</strong>
              </div>

              <div className="rddd-dialog-item">
                <span>Tenure</span>
                <strong>{selectedRow.tenure || "N/A"}</strong>
              </div>

              <div className="rddd-dialog-item">
                <span>Status</span>

                <span
                  className={`status-badge ${
                    selectedRow.status?.toLowerCase() === "active"
                      ? "status-active"
                      : "status-pending"
                  }`}
                >
                  {selectedRow.status || "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default RdDdReport;
